export default {
  // appName: "ZEREZ",
  search: "Suche...",
};
